// extracted by mini-css-extract-plugin
module.exports = {"background":"bd_ff","shopping__wrapper__examples":"bd_fg","active":"bd_fh","shopping__wrapper__project":"bd_fj"};